import { createAction, props } from '@ngrx/store';
export const setYAxisDate = createAction('[Scatter Plot] Set Y Axis Date', props());
